import {
  menu_default
} from "../../chunks/chunk.JW3F7MUK.js";
import "../../chunks/chunk.ZNAKKORO.js";
import "../../chunks/chunk.VVA35HTY.js";
import "../../chunks/chunk.TUVJKY7S.js";
import "../../chunks/chunk.UYAO2JRR.js";
import "../../chunks/chunk.B3BW2AY6.js";
export {
  menu_default as default
};
